import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    display: flex;
    flex-direction: column;

    width: 100%;
    height: ${(props) => `calc(${props.pageHeight}px - 77px)`};
    padding: 30px 30px 40px;
  `,
    LayoutContract: styled.div `
    width: 100%;
    height: 100%;
    overflow-y: auto;

    padding: 13px 10px;
    margin: 22px auto 0;

    background: ${SEMANTIC_COLORS.DEFAULT_FIELD_BOX_BACKGROUND};
    border-radius: 10px;
  `,
    Contract: styled.div `
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 10px 20px;

    line-height: 26px;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    background: ${SEMANTIC_COLORS.DEFAULT_TEXTAREA_BACKGROUND};
    border-radius: 16px;

    & h2 {
      margin-bottom: 6px;
    }

    & ol {
      padding-left: 20px;
    }

    & ol li {
      margin-bottom: 5px;
    }

    & > p {
      margin-top: 20px;
      font-weight: 700;
    }
  `,
    HighlightText: styled.div `
    color: ${SEMANTIC_COLORS.HIGHLIGHT_TEXT};
  `,
    InputHidden: styled.input `
    display: none;
  `,
    LayoutCheckboxSection: styled.div `
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 16px;
  `,
    LayoutCheckbox: styled.label `
    display: flex;

    width: fit-content;

    font-size: 18px;
    line-height: 26px;
    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
    cursor: pointer;
  `,
    Checkbox: styled.div `
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;

    width: 18px;
    height: 18px;
    margin: 5px 9px 0 0;

    background: ${SEMANTIC_COLORS.DEFAULT_CHECKBOX_BACKGROUND};
    border: 2px solid ${SEMANTIC_COLORS.DEFAULT_CHECKBOX_BORDER};
  `,
    LayoutFooter: styled.div `
    display: flex;
    justify-content: center;
    flex-shrink: 0;

    width: 100%;
    margin-top: 40px;
  `,
    GapRow: styled.div `
    width: ${(props) => `${props.width}px`};
  `,
};
